export default function (ctrl, formName) {
	return function (fieldName) {
		var Form = ctrl[formName] || ctrl.Form;
		if (ctrl && Form && fieldName && Form[fieldName]) {
			return Form[fieldName].$invalid && (Form[fieldName].$touched || Form.$submitted);
		}
	};
};
